import { makeObservable, observable } from "mobx"
import { BaseModel } from "@models/base.model"
import { Localization } from "@serializers/localization"
import { htmlToTextTransform } from "@lib/html"

export class GDPRModel extends BaseModel {
  constructor(params) {
    // @ts-ignore
    super(params)
    makeObservable(this)
  }

  @observable title: string = ""
  @observable content: string = ""
  @observable templates = [] as Localization[]

  getGDPRPage = async () => {
    try {
      const {
        title,
        content,
        templates,
      } = await this.Providers.GDPRProvider.find(this.Models.GlobalModel.lang)
      this.applyData({
        title,
        content,
        templates,
      })
    } catch {}
  }

  getTemplate = (key: string, simpleText = true) => {
    const find = this.templates.find((template) => template.key === key)
    if (!find) return ""

    return simpleText ? htmlToTextTransform(find.template) : find.template
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.applyData({ title: data?.title })
    // @ts-ignore
    this.applyData({ content: data?.content })
    // @ts-ignore
    this.applyData({ templates: data?.templates })
  }

  serialize = () => {
    return {
      title: this.title,
      content: this.content,
      templates: this.templates,
    }
  }
}
